export function getTicketTypes (state) {
  return state.types
}
export function getTicketType (state) {
  return state.type
}
export function getTicketGroup (state) {
  return state.group
}
export function getTicketMembers (state) {
  return state.members
}



// WEBPACK FOOTER //
// ./src/vuex/tickets/getters.js